import { DEFAULT_LOCALE, type SupportedLocale } from "./config";

function normalizeLocale(locale: string | SupportedLocale): SupportedLocale {
  const base = locale.split("-")[0] as SupportedLocale;
  if (base === "fi" || base === "en" || base === "sv") return base;
  return DEFAULT_LOCALE;
}

export function getNumberLocale(locale: string | SupportedLocale): string {
  const normalized = normalizeLocale(locale);
  switch (normalized) {
    case "fi":
      return "fi-FI";
    case "en":
      return "en-US";
    case "sv":
      return "sv-SE";
    default:
      return "fi-FI";
  }
}

export function formatNumber(
  value: number,
  locale: string | SupportedLocale,
  options: Intl.NumberFormatOptions = {},
): string {
  return new Intl.NumberFormat(getNumberLocale(locale), options).format(value);
}

export function formatFixed(
  value: number,
  locale: string | SupportedLocale,
  digits: number,
): string {
  return formatNumber(value, locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}
